module.exports = __webpack_public_path__ + "static/img/cp03.642e4b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cp03.png
// module id = WSFS
// module chunks = 1